const COLOURS = [
  'pink',
  'salmon',
  'yellow',
  'lavanda',
  'blue',
  'ocean-blue',
  'mint-green',
  'olive-green',
]

export default COLOURS
